export default {"src":"/_next/static/media/image_remix.845f342b.gif","height":1044,"width":498,"blurWidth":0,"blurHeight":0};